import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/button/Button";
import ImagesDropdown from "../../../../components/inputs/imagesDropdown/ImagesDropdown";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import TimeInput from "../../../../components/inputs/timeInput/TimeInput";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchRegionImages } from "../../../../features/images/regionImages/regionImagesSlice";
import { createRegion } from "../../../../features/regions/regionsSlice";
import { convertTimeStringToUTCWithToday } from "../../../../utils/timeZone";
import styles from "./addNewRegion.module.css";

const AddNewRegion = () => {
  const [name, setName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [image, setImage] = useState("");

  const dispatch = useDispatch();
  const { fetchStatus, list } = useSelector(
    (state) => state.regionImages
  );
  const { addStatus } = useSelector((state) => state.regions);
  const { timeZone } = useSelector((state) => state.timeZone);

  const handleCreateNewRegionSubmit = () => {
    if (name !== "" && startTime !== "" && endTime !== "" && image !== "") {
      const start = convertTimeStringToUTCWithToday(startTime, timeZone);
      const end = convertTimeStringToUTCWithToday(endTime, timeZone);

      dispatch(
        createRegion({
          name,
          peakTimeStart: start.toISOString(),
          peakTimeEnd: end.toISOString(),
          image: image._id,
        })
      );
    }
  };

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchRegionImages());
    }
  }, [dispatch, fetchStatus]);

  if (fetchStatus === "loading" || addStatus === "loading") {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <SettingsPagesContainer
      title="اضافة منطقة جديدة"
      displayContainerClassName={styles.formDisplay}
    >
      <div className={styles.formShell}>
        <div className={styles.inputWrapper}>
          <TextWrapper textStyle="textMid">اسم المنطقة</TextWrapper>
          <TextInput
            height="52px"
            width="100%"
            borderRadius="12px"
            placeHolder="اسم المنطقة"
            bgColor={"grey"}
            bordered={true}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className={styles.timeGrid}>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">نهاية وقت الذروة</TextWrapper>
            <TimeInput value={endTime} onChange={(e) => setEndTime(e)} />
          </div>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">بداية وقت الذروة</TextWrapper>
            <TimeInput value={startTime} onChange={(e) => setStartTime(e)} />
          </div>
        </div>
        <div className={styles.inputWrapper}>
          <TextWrapper textStyle="textMid">صورة المنطقة</TextWrapper>
          <ImagesDropdown data={list} value={image} setValue={setImage} />
        </div>
        <div className={styles.createNewRegionBtnWrapper}>
          <Button
            size="bigSize"
            variant="blackVariant"
            functionallity={handleCreateNewRegionSubmit}
          >
            <TextWrapper textStyle="textMid">تسجيل المنطقة الجديدة</TextWrapper>
          </Button>
        </div>
      </div>
    </SettingsPagesContainer>
  );
};

export default AddNewRegion;
